<template>
  <FormInputWrapper :error="error" :label="label" :required="required">
    <div class="flex flex-col gap-y-1">
      <div v-for="option in answerOptions" :key="option" class="min-h-8 py-1 pr-2 text-sm md:px-4 [&_label]:tracking-normal [&_span]:ml-6 [&_span]:block [&_span]:break-words">
        <MoleculesCheckbox :id="`${questionId}-${option}`" :model-value="checkedSet.has(option)" @update:model-value="toggleOption(option, $event)">
          {{ option }}
        </MoleculesCheckbox>
      </div>
    </div>
  </FormInputWrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { FormInputWrapper } from '@/wabunka-src/common/components';

interface Props {
  label: string;
  questionId: string;
  modelValue: string[];
  answerOptions: string[];
  onUpdateModelValue?: (value: string[]) => void;
  required?: boolean;
  error?: string;
}

const props = withDefaults(defineProps<Props>(), {
  onUpdateModelValue: undefined,
  required: true,
  error: '',
});

const checkedSet = computed(() => new Set(props.modelValue));

const toggleOption = (option: string, checked: boolean) => {
  const current = [...(props.modelValue || [])];
  if (checked) {
    current.push(option);
  } else {
    const index = current.indexOf(option);
    if (index > -1) {
      current.splice(index, 1);
    }
  }
  props.onUpdateModelValue?.(current);
};
</script>
